import React from 'react';
import { CreditCard, Inbox, Search, Plus } from 'lucide-react';

export default function EmptyState({
  type = 'transactions',
  title,
  description,
  actionLabel,
  onAction
}) {
  const defaults = {
    transactions: {
      icon: <Inbox size={44} style={{ color: 'var(--text-muted)', opacity: 0.6 }} />,
      title: 'No Transactions Found',
      description: 'You have no recorded transactions for this period or filter.'
    },
    budgets: {
      icon: <CreditCard size={44} style={{ color: 'var(--text-muted)', opacity: 0.6 }} />,
      title: 'No Active Budgets',
      description: 'Set up account balances or target limits to track spending.'
    },
    search: {
      icon: <Search size={44} style={{ color: 'var(--text-muted)', opacity: 0.6 }} />,
      title: 'Zero Search Results',
      description: 'No items match your search query. Try clearing filters.'
    }
  };

  const current = defaults[type] || defaults.transactions;

  return (
    <div
      className="glass-panel"
      style={{
        padding: '36px 24px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        borderRadius: '24px',
        gap: '12px',
        margin: '16px 0'
      }}
    >
      <div
        style={{
          padding: '16px',
          borderRadius: '50%',
          background: 'rgba(255, 255, 255, 0.03)',
          border: '1px solid var(--border-glass)'
        }}
      >
        {current.icon}
      </div>

      <h3 style={{ fontSize: '16px', fontWeight: '600', color: 'var(--text-main)', margin: 0 }}>
        {title || current.title}
      </h3>

      <p style={{ fontSize: '13px', color: 'var(--text-muted)', margin: 0, maxWidth: '280px' }}>
        {description || current.description}
      </p>

      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="btn-primary touch-target"
          style={{
            marginTop: '8px',
            padding: '10px 20px',
            fontSize: '13px',
            borderRadius: '12px',
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            width: 'auto'
          }}
        >
          <Plus size={16} />
          {actionLabel}
        </button>
      )}
    </div>
  );
}
